import { EAreaEventType } from 'detailsv2/structure';
import yup from 'utils/yup';

const selectOptionSchema = yup.object({
  // id: yup.mixed().oneOf([yup.string(), yup.number(), null]).nullable(),
  name: yup.string().required('Name is required'),
});

export const suggestedAreaValidationSchema = yup.object().shape({
  attachedPage: selectOptionSchema.required(),
  areaType: yup.mixed<EAreaEventType>().oneOf(Object.values(EAreaEventType)).required(),
});
